import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type * as Types from '../../codegen/types.js';

const defaultOptions = {} as const;
export type GetProductMarketingQueryVariables = Types.Exact<{
  input: Types.GetProductMarketingInput;
}>;

export type GetProductMarketingQuery = {
  __typename?: 'Query';
  getProductMarketing: {
    __typename?: 'ProductMarketingResponse';
    type?: Types.MarketingType | null;
    products?: Array<{
      __typename?: 'AddOnProduct';
      id: string;
      name: string;
      title: string;
      description: string;
      imageURLs: Array<string | null>;
      slug: string;
      key: string;
      variants: Array<{
        __typename?: 'AddOnVariant';
        sku: string;
        price: { __typename?: 'AddOnPrice'; centAmount: number; currencyCode: string };
      } | null>;
    } | null> | null;
  };
};

export const GetProductMarketingDocument = gql`
  query getProductMarketing($input: GetProductMarketingInput!) {
    getProductMarketing(input: $input) {
      type
      products {
        id
        name
        title
        description
        imageURLs
        slug
        key
        variants {
          sku
          price {
            centAmount
            currencyCode
          }
        }
      }
    }
  }
`;

/**
 * __useGetProductMarketingQuery__
 *
 * To run a query within a React component, call `useGetProductMarketingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductMarketingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductMarketingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductMarketingQuery(
  baseOptions: Apollo.QueryHookOptions<GetProductMarketingQuery, GetProductMarketingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductMarketingQuery, GetProductMarketingQueryVariables>(
    GetProductMarketingDocument,
    options,
  );
}
export function useGetProductMarketingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductMarketingQuery, GetProductMarketingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductMarketingQuery, GetProductMarketingQueryVariables>(
    GetProductMarketingDocument,
    options,
  );
}
export type GetProductMarketingQueryHookResult = ReturnType<typeof useGetProductMarketingQuery>;
export type GetProductMarketingLazyQueryHookResult = ReturnType<typeof useGetProductMarketingLazyQuery>;
export type GetProductMarketingQueryResult = Apollo.QueryResult<
  GetProductMarketingQuery,
  GetProductMarketingQueryVariables
>;
